import { getTrackingDisabled } from '#services/storage'
import { COLLECTION_ENDPOINT } from 'ag-common/tools/tracking'
import { pianoAnalytics } from 'piano-analytics-js'
import actions from 'redux-auto'

export function addScreen(site, screen) {
  // in local dev we will never track anything
  if (DEBUG) {
    return
  }


  if (!pianoAnalytics.getConfiguration('collectDomain') || !pianoAnalytics.getConfiguration('site')) {
    initialize()
  }

  const trackingDisabled = getTrackingDisabled()
  if (!trackingDisabled) {
    pianoAnalytics.sendEvent('page.display', {
      page: site,
      page_chapter1: screen,
    })
  }
}

export function changeTrackingDisabled(disableTracking) {
  // AM => Audience mesaurement => piano analytics
  const audienceMeasurement = 'AM'

  if (disableTracking) {
    pianoAnalytics.consent.setByPurpose(audienceMeasurement, 'opt-out')
    actions.settings.setTrackingDisabled({trackingDisabled: true})
  } else {
    pianoAnalytics.consent.setByPurpose(audienceMeasurement, 'opt-in')
    actions.settings.setTrackingDisabled({trackingDisabled: false})
  }
}

function initialize() {
  pianoAnalytics.setConfigurations({
    'site': SITE_ID,
    'collectDomain': COLLECTION_ENDPOINT,
  })
}
